import axios from "../../interceptors/axiosInterceptor";
import {
  FETCH_BANNERS_URL,
  UPDATE_BANNER_PRODUCTS_URL,
  UPDATE_BANNER_URL,
  UPDATE_BANNER_SEQUENCE_URL,
} from "../../config/Url";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  normalizeBannerResponseDto,
  normalizeFetchBanners,
} from "../../normalizer/BannerNormalizer";
import { SOMETHING_WENT_WRONG } from "../../config/constants";
import {
  IBannersResponse,
  IBannersResponseNormalized,
  IUpdateBannerPayload,
} from "../../interfaces/banner.interface";

export const fetchBannersApiCall = (cityId: string, customerChannel: string) =>
  new Promise<IBannersResponseNormalized[]>((resolve, reject) => {
    axios
      .get(
        FETCH_BANNERS_URL.replace("{cityId}", cityId).replace(
          "{customerChannel}",
          customerChannel
        ),
        getAuthOptions()
      )
      .then((response) => {
        if (response) {
          const data: IBannersResponse[] = response.data;
          const normalizedData = normalizeFetchBanners(data);

          resolve(normalizedData);
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

// export const fetchBannerProductsApiCall = (bannerId: string) =>
//   new Promise<IBannerProductsResponse[]>((resolve, reject) => {
//     const url = FETCH_BANNER_PRODUCTS_URL.replace("{banner_id}", bannerId);
//     axios
//       .get(url, getAuthOptions())
//       .then((response) => {
//         if (response) {
//           const data: IBannerProductsResponse[] = response.data;
//           resolve(data);
//         } else {
//           reject({ errors: SOMETHING_WENT_WRONG });
//         }
//       })
//       .catch((error) => {
//         const errorPayload = normalizeCatchErrors(error.response);
//         reject(errorPayload);
//       });
//   });

export const updateBannerApiCall = (payload: IUpdateBannerPayload) =>
  new Promise<IBannersResponseNormalized>((resolve, reject) => {
    axios
      .post(UPDATE_BANNER_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IBannersResponse = response.data;
          resolve(normalizeBannerResponseDto(data));
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const updateBannerProductsApiCall = (bannerId: string, payload: any) =>
  new Promise<void>((resolve, reject) => {
    const url = UPDATE_BANNER_PRODUCTS_URL.replace("{banner_id}", bannerId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const updateBannerSequenceApiCall = (
  cityId: string,
  payload: string[]
) => {
  return new Promise<void>((resolve, reject) => {
    const url = UPDATE_BANNER_SEQUENCE_URL.replace("{cityId}", cityId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};
